import { getMediaContents } from '../feed_fetchers/rss';

const domParser = new DOMParser();

const youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/watch\?.+&v=))([\w-]{11})(?:.+)?$/;

export const firstImg = (item) => {
  const imgTag = domParser.parseFromString(item.content, "text/html")
    .getElementsByTagName("img")[0];
  if (!imgTag) return { ...item, image: item.image };
  const raw = imgTag.getAttribute('src');
  if (!raw) return { ...item, image: item.image };
  try {
    return { ...item, image: new URL(raw, item.link).href };
  } catch (_) {
    return { ...item, image: imgTag.src || item.image };
  }
}

export const withSource = (source) => (item) => {
  return {...item, source };
}

export const fixHHDImageLinks = (item) => {
  return {
    ...item,
    image: item.image.replace("hiphopdaily.com", "thesneakercrush.com")
      .replace("w=350&h=350", "w=600&h=450"),
  }
}

export const fixMercuryHTMLSpaces = (item) => {
  return {
    ...item,
    content: item.content && item.content
      .split("&#xFFFD;").join(" ").split("&#xA0;").join(" "),
  }
}

export const removeEbayBlock = (item) => {
  const idx = item.content && item.content.indexOf("<div id=\"ebay-embed\">");
  if (idx && idx > 0) {
    return { ...item, content: item.content.slice(0, idx) };
  }
  return item;
}

const sfMarker = `<p>Originally seen on <a rel="nofollow" href="https://www.sneakerfiles.com">SneakerFiles</a>:`;

export const clearSneakerFilesArticles = (item) => {
  let contentLines = (item.content || "").split("\n");
  if (contentLines.length < 4) { return item; }

  if (contentLines[0].startsWith(sfMarker)) {
    contentLines.shift();
  }

  if (contentLines[0].startsWith("<p><img title=")
    && contentLines[0].includes(item.image)
    && contentLines[0].indexOf(">", 5) === contentLines[0].length - 5) {
    contentLines.shift();
  }

  if (contentLines[contentLines.length - 1] === "") {
    contentLines.pop();
  }

  if (contentLines[contentLines.length - 1].startsWith(sfMarker)) {
    contentLines.pop();
  }

  return { ...item, content: contentLines.join("\n") };
}

export const prependComplexSneakersVideos = (item) => {
  const content = getMediaContents(item.feedItem, 'video').reduce((content, link) => {
    const match = link.match(youtubeRegex);
    if (match && match[1].length === 11) {
      return `<iframe src="https://www.youtube.com/embed/${match[1]}?rel=0&controls=0&showinfo=0"></iframe>\n${content}`;
    }
    return content;
  }, item.content || "");

  return { ...item, content };
}
